import Profile from "views/dashboard/profile";
import { MdPersonOutline } from "react-icons/md";

const routes = [
  {
    name: "Profile",
    layout: "/dashboard",
    path: "profile",
    icon: <MdPersonOutline className="h-6 w-6" />,
    component: <Profile />,
  },
];

export default routes;
